const getAnalytics = async(slug, sitetag) => {

  return window.fetch(`https://8auaiv8sdk.execute-api.us-east-1.amazonaws.com/dev/analytics/test?slug=${slug}&sitetag=${sitetag}`)
    .then(res => res.json())
    .then((data) => {
      //console.log(data)
      let result = {};
      data.map(item => result[`${item.ITEM_ID}`] = { item_id: item.ITEM_ID, impressions: item.IMPRESSIONS, clicks: item.CLICKS });
      return result;
    })
    .catch(console.log);
}

export default getAnalytics;
